export enum PartnerEnum {
  BRZIPREGLED = "company_brzipregled"
}
